import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { SitesListing } from "gatsby-theme-gba"
const SiteListingEditable = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} key={blok._uid}>
      <SitesListing
        heading={blok.heading}
        noEntriesText={blok.noEntriesText}
        currentLanguage={blok.currentLanguage}
        btnText={blok.btnText}
        envBg={blok.evnImage}
        foodBg={blok.foodBg}
        wasserBg={blok.waterBg}
        groupBg={blok.groupBg}
        cosmeticsBg={blok.cosmeticsBg}
        GBALogo={blok.GBALogo}
        tileDefaultImage={blok.defaultImage}
      ></SitesListing>
    </div>
  )
}

export default SiteListingEditable
